
<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <button type="button" id="BtnPopup" (click)="Show()" style="display:none">Search</button>
        <button type="button" id="btnColSave" class="btn btn-block btn-primary float-sm-right" style="display:none">Columns</button>"
        <!--table-->
        <table #dataTable class="display" style="width:100%"></table>
        <!--Action popup Page-->
        <div class="modal" id="btnPopupartDetails" style="display:none">
          <div class="modal-dialog modal-xl custome-modal">
            <div class="modal-content" id="modal_contentArt">
              <div class="modal-header" style="text-align:center">
                <h4 class="modal-title">Proofing-MailBody  </h4>
                <button type="button" class="close" data-dismiss="modal" (click)="hide()">×</button>
              </div>
              <!--<div class="modal-body" id="popupbody">-->
              <div class="modal-body" style="overflow:hidden !important" id="popupbody">
                <div class="row">
                  <!--Left side panel-->
                  <div class="col-6 container-fluid">
                    <div class="form-group">
                      <div class="row">
                        <label>Proofing Type<em>*</em></label>
                        <select class="form-control" id="ddlProofingType">
                          <option value="EG" selected="selected">EG</option>
                          <option value="EPT">EPT</option>
                          <option value="EPDS">EPDS</option>
                          <option value="CASPER">CASPER</option>
                        </select>

                        <div class="col-sm-6" name="JournalMode">
                          <label for="journalmode ">Journal Mode</label>
                          <select class="form-control" id="ddlJournalMode">
                            <option value="PM">PM</option>
                            <option value="NonPM">NonPM</option>
                          </select>
                        </div>

                        <div class="col-sm-6">
                          <label for="ddlJournalId ">JournalId<em>*</em></label>
                          <select id="ddlJournalId" class="form-control">
                            <option *ngFor="let item of JournalList" value={{item.ID}}>
                              {{item.Acronym}}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <div class="row">
                        <div class="col-sm-6">
                          <label for="ddlArticleStage">ArticleStage</label>
                          <select id="ddlArticleStage" class="form-control">
                            <option *ngFor="let item of ArticleStageList" value={{item.ID}}>
                              {{item.StageName}}
                            </option>
                          </select>
                        </div>

                        <div class="col-sm-6">
                          <label for="ddlProofingStage">ProofingStage</label>
                          <select id="ddlProofingStage" class="form-control">
                            <option *ngFor="let item of ProofingStageList" value={{item.ID}}>
                              {{item.Stage}}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>


                    <div class="form-group">
                      <div class="row">
                        <div class="col-sm-4">
                          IsReminder
                          <input id="Txt_IsReminder" type="checkbox" autocomplete="off">
                        </div>

                        <div class="col-sm-4">
                          ReminderNo
                          <input id="Txt_ReminderNo" type="checkbox" autocomplete="off">
                        </div>
                        <div class="col-sm-4">
                          IsConfirmation
                          <input id="Txt_IsConfirmation" type="checkbox" autocomplete="off">
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="col-12">
                        <label for="Txt_SammpleFileName">SampleFileName<em>*</em></label>
                        <input id="Txt_SammpleFileName" type="text" class="form-control" maxlength="25" autocomplete="off">
                      </div>
                    </div>
                  </div>
                  <!--Right side panel-->
                  <div class="col-6">
                    <div class="form-group col-12" id="Divmail">
                      <label for="Txt_MailBody">MailBody<em>*</em></label>
                      <textarea id="Txt_MailBody" class="form-control rounded-0" autocomplete="off" data-origin="textarea"> </textarea>
                    </div>
                  </div>
                </div>
              </div>
              <!--popup body end-->
              <div class="modal-footer">
                <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>
                <button type="button" class="btn btn-outline-success waves-effect waves-light" title="{{popUpButtonText}}" id="btnWF" (click)="UpdateTemplateData()"> {{popUpButtonText}} </button>
              </div>
              <div id="LoadingImagePopup">
                <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading..." />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

